export function addressLocationsValidate(address){
    var result = true;
    result = validateZipcode(address.zipcode);
    // result = validateState(address.channel_sale);
    // result = validateCity(address.unique_order_number);
    
    return result;
}

function validateZipcode(zipcode){    
    if(/^\d+$/.test(zipcode) && zipcode.toString().length == 5) return true;
    else return false;
}

// function validateState(state){
//     console.log(state);
//     return true;

//     // if(typeof channel_sale === 'string' && channel_sale.trim() !== '') return true;
//     // else return false;
// }

// function validateCity(city){
//     console.log(city);
//     return true;
    
//     // if(typeof uon === 'string' && uon.trim() !== '') return true;
//     // else return false;
// }